
import * as constants from '../Constatnts'
import axios from 'axios';



export function getAccounts() {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        constants.API_URL + "/transaction/account",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code === "0") {
        return response.data.searchResult || [];
      }

      return [];
    } catch (error) {
      return [];
    }
  };
}


export function saveAccount(account, key = "") {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key !== "") {
        // Update existing account
        response = await axios.put(
          `${constants.API_URL}/transaction/account/${key}`,
          account,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new account
        response = await axios.post(
          `${constants.API_URL}/transaction/account`,
          account,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
          return response.data.data.key;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}
// export function saveAccount(account, key) {
//     return (dispatch, getState) => {
//         account.ActionOn = firebase.firestore.FieldValue.serverTimestamp()
//         account.ActionBy = getState().user.user.Name
//         account.ActionByUID = getState().user.user.UID
//         account.ActionByEmailID = getState().user.user.EmailID

//         if (key !== "") {
//             account.Action = constants.AUDIT_TRAIL_EDIT
//             return database.collection("Accounts").doc(key).update({
//                 ...account
//             }).then(() => {
//                 return key
//             }).catch(function (error) {
//                 console.error("Error updating account: ", error);
//             })
//         }
//         else {
//             account.Action = constants.AUDIT_TRAIL_NEW
//             return database.collection("Accounts").add({
//                 ...account
//             })
//                 .then(function (docRef) {
//                     return docRef.id
//                 })
//                 .catch(function (error) {
//                     console.error("Error adding account: ", error);
//                 })
//         }
//     }
// }

export function deleteAccount(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.delete(
        constants.API_URL + `/transaction/account/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code === "0") {
        return true;
      } else {
        alert(response.data.message || "Failed to delete account");
        return false;
      }

    } catch (error) {
      alert("Failed to delete account");
      return false;
    }
  };
}








export function checkIfAccountIsUnique(account, registrationID, stores) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.post(
        `${constants.API_URL}/transaction/account/unique`,
        {account, registrationID, stores},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.accountIsUnique;;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}
